import {choice} from 'constants/url';
import useDelete from 'components/hooks/useDelete';
import {DeletingOptions} from 'components/grid-dx/types';

function useDeleteChoice() {
  const deleteChoice = useDelete(choice);
  return (deletingOptions: DeletingOptions) => deleteChoice(deletingOptions);
}

export default useDeleteChoice;
